<div class="container">
    <div class="top-section">
        <div class="heading-container">
            <mat-icon class="icon" (click)="goBack()">arrow_back</mat-icon>
        </div>
        &nbsp;
        <p class="top-left-section">{{ "structure.heading.myStructures" | translate }}</p>

        <div class="top-right-section" *ngIf="structures.totalCount">
            <app-search-bar
                [label]="'genericDialogBox.label.search' | translate"
                [placeholder]="'genericDialogBox.placeHolder.searchStructure' | translate"
                [initialValue]="searchQuery"
                [debounceTime]="500"
                (search)="triggerSearch($event)"
                [suffixCloseIcon]="'close'"
                [suffixSearchIcon]="'search'"
            >
            </app-search-bar>
        </div>
    </div>

    <div class="bottom-section">
        <div class="bottom-top-section">
            <div class="bottom-top-section" *ngIf="showSelectAllCheckbox">
                <app-button variant="hero" [disabled]="isBulkActionDisabled" (onClick)="onBulkPublish()">
                    {{ "structure.button.publishBtn" | translate }}
                </app-button>
                <app-button
                    variant="white"
                    buttonClass="shadow-btn"
                    [disabled]="isBulkActionDisabled"
                    (onClick)="onBulkDelete()"
                >
                    {{ "structure.button.deleteBtn" | translate }}
                </app-button>
                <mat-checkbox
                    [checked]="isAllSelected"
                    class="hidden-checkbox"
                    [indeterminate]="isIndeterminate"
                    (change)="onToggleSelectAll($event)"
                >
                </mat-checkbox>
                <app-button variant="hero" (click)="onSelectAllButtonClick()">
                    {{
                        isAllSelected
                            ? ("structure.button.unselectAllBtn" | translate)
                            : ("structure.button.selectAllBtn" | translate)
                    }}
                </app-button>
            </div>
            <div class="filter-section" *ngIf="structures.totalCount">
                <mat-form-field class="custm-filter box-outline dense-3" appearance="outline">
                    <mat-label>Filter</mat-label>
                    <mat-select
                        placeholder="All"
                        [(value)]="selectedStatus"
                        (selectionChange)="filterStatus($event.value)"
                    >
                        @for (statusOption of statusOptions; track statusOption) {
                        <mat-option [value]="statusOption">{{ statusOption }}</mat-option>
                        }
                    </mat-select>
                    <mat-icon matSuffix>filter_alt</mat-icon>
                </mat-form-field>
            </div>
        </div>

        <div class="bottom-structure-list-section">
            <div class="spinner-container" *ngIf="loading">
                <mat-spinner class="loading-spinner" [diameter]="70"></mat-spinner>
            </div>
            <app-my-structures-list
                *ngIf="structures"
                [structures]="structures"
                [selectedStructureIds]="selectedStructureIds"
                [loadingStructure]="loading"
                (structureUpdated)="onStructuresUpdated([$event])"
                (structureDeleted)="onStructuresDelete($event)"
                (loadMore)="loadMoreMyStructures()"
                (checkboxToggled)="onStructureCheckboxToggled($event)"
            ></app-my-structures-list>
        </div>
    </div>
</div>
